var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.annotation)?_c('a',{staticClass:"copilot-annotation text-decoration-none",attrs:{"href":_vm.annotation.url,"target":"_blank"}},[_c('sup',[_vm._v(" ["+_vm._s(_vm.annotation.index)+"] ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }